/** @file GET /api/v1/projects/:id/images/:sha256 (the stored PNG, X3); 404 answers null. */
import { throwError } from '@pose2d/format/throwError';
import type { FetchLike } from './createApiClient';

/** The PNG bytes; any status other than 200/404 is the client's transport NOT_FOUND (kind `route`) with the status. */
export async function fetchImagePng(fetchFn: FetchLike, projectId: string, sha256: string): Promise<Uint8Array | null> {
  const path = `/api/v1/projects/${encodeURIComponent(projectId)}/images/${encodeURIComponent(sha256)}`;
  const res = await fetchFn(path, { method: 'GET', credentials: 'same-origin' });
  if (res.status === 404) return null;
  if (!res.ok) throwError('NOT_FOUND', { kind: 'route', ref: `GET ${path}` }, { hint: `HTTP ${String(res.status)} while reading an image` });
  return new Uint8Array(await res.arrayBuffer());
}
